import React, { Fragment } from 'react'
import { SpacerHorizontal, Typography } from '@klarna/bubble-ui'
import styles from './CustomOfferBreakdown.css'

interface ItemDetail {
  text: string
  isStrong: boolean
}

interface Item {
  item: string
  detail: ItemDetail
}

interface CustomOfferBreakdownProps {
  items: Item[]
}

const CustomOfferBreakdown: React.FC<CustomOfferBreakdownProps> = ({ items }) => (
  <Fragment>
    <style>{styles}</style>
    <div className='breakdown-container-outer'>
      {items.map((item, index) => (
        <div>
          <div key={index} className='breakdown-container-inner'>
            <Typography>{item.item}</Typography>
            {item.detail.isStrong ? (
              <Typography textToken='text-style/text/paragraphs/body/bold'>{item.detail.text}</Typography>
            ) : (
              <Typography>{item.detail.text}</Typography>
            )}
          </div>
          <SpacerHorizontal spaceToken='space.150' />
        </div>
      ))}
    </div>
  </Fragment>
)

export default CustomOfferBreakdown